import { AppSpecificCopy } from '../index';

export const copy: AppSpecificCopy = {
  pages: {
    index: {
      consents:
        'We’ll use your details to suggest the best Zopa products for you and send you occasional news and offers. We’ll never share your details with third parties without your permission and you can ',
      subtitle: `Check if you're eligible for a Zopa loan by confirming a few details below. This'll take 3 minutes.`,
      title: 'Check your eligibility',
      marketingAdditional: '',
    },
  },
  annualIncome: {
    subtitle:
      'Yours only, and only from your work or pension. If your income is due to change within 12 months, please provide the lower figure.',
    title: "What's your annual income before tax?",
  },
  dependants: {
    subtitle: 'Someone who relies on you financially. This includes children, spouses or friends.',
    title: 'Dependants',
  },
};
